<template>
  <section class="section section-shaped section-lg my-0">
    <div class="text-center" style="padding: 90px 0px; color: white; font-family: Quicksand; letter-spacing: -2px;">
        <p style="margin: 50px; font-size: 2rem;">Si quieres conocer todos los beneficios y descuentos<br> de nuestras marcas aliadas de la Tarjeta</p>
        <img style="width: 60%;" src="img/brand/logo.svg" alt="">
        <p style="margin: 50px; font-size: 2.5rem;">
          <router-link v-bind:to="'/beneficios'" style="color: white"><b>Haz clic aquí y descúbrelo</b></router-link>
          </p>
      </div>
  </section>
</template>
<script>
import { isArray } from "util";
import BCarousel from "bootstrap-vue/es/components/carousel/carousel";
import BCarouselSlide from "bootstrap-vue/es/components/carousel/carousel-slide";

const axios = require("axios");

export default {
  components: {
    BCarousel,
    BCarouselSlide
  },
  data() {
    return {
      loading: false,
      errors: [],
      slides: [],
      slides_fijos: [
        {
          banner: 'img/custom/banner-01.jpg', 
          nombre: '',
          beneficio: []
        }
      ],
    };
  },
  methods: {
    async cargarBanners() {
      this.errors = [];
      this.loading = true;
      try {
        var response = await axios.get(
          "https://8lp5pofbb8.execute-api.us-east-1.amazonaws.com/api/aliado/banner-home"
        );
        if (response.data) {
          this.slides = JSON.parse(response.data.body);
        } else {
          this.errors.push(
            "Ocurrió un error al intentar consultar el Beneficio indicado"
          );
        }
        this.loading = false;
      } catch (err) {
        this.errors.push(
          "Ocurrió un error al intentar consultar el Beneficio indicado"
        );
        this.loading = false;
      }
    }
  },
  mounted: function() {
    this.cargarBanners();
  }
};
</script>
<style>
@font-face {
    font-family: 'Quicksand';
    font-style: bold;
    font-weight: 700;
    src: local('Raleway'), local('Raleway-Regular'), url("/fonts/Quicksand-Bold.otf") format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
}

@font-face {
    font-family: 'Quicksand';
    font-style: normal;
    font-weight: 400;
    src: local('Raleway Italic'), local('Raleway-Italic'), url("/fonts/Quicksand-Regular.otf") format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
}

@font-face {
    font-family: 'Quicksand';
    font-weight: 300;
    src: local('Raleway Italic'), local('Raleway-Italic'), url("/fonts/Quicksand-Light.otf") format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
}

</style>
